import { Box, Checkbox, CircularProgress, Grid, IconButton, TableCell, TableRow, TextField } from '@material-ui/core'
import { SearchOutlined } from '@material-ui/icons'
import { IOProps } from 'react-compose-io'
import { Controller, ControllerRenderProps } from 'react-hook-form'
import { Botao } from '../../../../components/Botao'
import { CustomDialog } from '../../../../components/CustomDialog/CustomDialog'
import { Tabela } from '../../../../components/Tabela'
import { Tipografia } from '../../../../components/Tipografia'
import { FormValuesBuscarOPs } from '../../../../types/iniciarNovoCicloTypes'
import { OPPorPedidoResponse, OrdemPagamentoBuscarResponse } from '../../../../types/regularizacaoOPsTitulosTypes'
import { cabecalhoTabelaResultadoOPS } from '../../../../types/tabelaTypes'
import { formateCurrency, validarTexto } from '../../../../utils/stringUtils'
import { ModalVincularOPIO } from './ModalVincularOP.IO'

export type ModalVincularOPProps = {
  isShow: boolean
  opsPedido: OPPorPedidoResponse[]
  incluirOps: (ops: OPPorPedidoResponse[]) => void
  fecharModal: () => void
}

export function ModalVincularOPView({ _io, isShow }: IOProps<ModalVincularOPIO, ModalVincularOPProps>) {
  const { Form, ContainerDateInputs, SituacaoOp, ContainerBotoes } = _io.styles

  function DateInput(field: ControllerRenderProps<FormValuesBuscarOPs, 'dataInicio'> | ControllerRenderProps<FormValuesBuscarOPs, 'dataFim'>) {
    return <TextField type="date" variant="outlined" size="small" {...field} inputProps={{ max: _io.dataAtualPadrao }} />
  }

  function situacaoOp(item: OrdemPagamentoBuscarResponse) {
    if (_io.vinculadaCiclo(item)) return <SituacaoOp>{`Vinculada ao ciclo ${Number(item.cicloId).toLocaleString('pt-BR')}`}</SituacaoOp>
    if (_io.jaIncluida(item)) return <SituacaoOp>Já incluída no pedido</SituacaoOp>
    return null
  }

  function linhaTabela(props: { item: OrdemPagamentoBuscarResponse }) {
    const { item } = props
    const isItemSelected = _io.isSelecionada(item)
    const labelId = `vincular-op-checkbox-${item.ordemPagamentoId}`

    return (
      <TableRow hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1} key={item.ordemPagamentoId} selected={isItemSelected}>
        <TableCell padding="checkbox">
          <Checkbox
            onChange={(event) => _io.handleCheckbox(event, item)}
            disabled={!_io.disponivel(item)}
            checked={isItemSelected}
            inputProps={{ 'aria-labelledby': labelId }}
          />
        </TableCell>
        <TableCell align="center" id={labelId}>
          {item.ordemPagamentoId}
        </TableCell>
        <TableCell align="center">{formateCurrency(item.valorPagamento)}</TableCell>
        <TableCell align="center">{new Date(item.dataEmissao).toLocaleDateString()}</TableCell>
        <TableCell align="center">{validarTexto(item.emitente, 'Sem emitente')}</TableCell>
        <TableCell align="center">{item.bancoId}</TableCell>
        <TableCell align="center">{validarTexto(item.descricao, 'Sem descrição')}</TableCell>
        <TableCell align="center">{situacaoOp(item)}</TableCell>
      </TableRow>
    )
  }

  return (
    <CustomDialog maxWidth="lg" fecharHabilitado fecharModal={_io.limparDadosModal} open={isShow} id="vincularOP" titulo="Vincular OP">
      <Box>
        <Form onSubmit={_io.handleSubmit(_io.buscarOps)}>
          <Grid container spacing={2} alignItems="center">
            <Grid item md={2}>
              <Controller
                name="ordemPagamentoId"
                control={_io.control}
                render={({ field }) => <TextField type="number" label="Número da OP" variant="outlined" size="small" {...field} />}
              />
            </Grid>
            <Grid item md={'auto'}>
              <ContainerDateInputs>
                <Controller name={'dataInicio'} control={_io.control} render={({ field }) => DateInput(field)} />
                <Tipografia>até</Tipografia>
                <Controller name={'dataFim'} control={_io.control} render={({ field }) => DateInput(field)} />
              </ContainerDateInputs>
            </Grid>
            <Grid item md={2}>
              <Controller
                name="emitente"
                control={_io.control}
                render={({ field }) => <TextField type="text" label="Emitente" variant="outlined" size="small" {...field} />}
              />
            </Grid>
            <Grid item md={1}>
              <Controller
                name="bancoId"
                control={_io.control}
                render={({ field }) => <TextField type="number" label="Banco" variant="outlined" size="small" {...field} />}
              />
            </Grid>
            <Grid item md={1}>
              <Controller
                name="valor"
                control={_io.control}
                render={({ field }) => <TextField type="number" label="Valor" variant="outlined" size="small" {...field} />}
              />
            </Grid>
            <Grid item md={1}>
              <IconButton color="primary" type="submit">
                <SearchOutlined />
              </IconButton>
            </Grid>
          </Grid>
        </Form>
      </Box>

      {_io.loading ? (
        <Grid container justifyContent="center">
          <CircularProgress />
        </Grid>
      ) : (
        _io.resultado.length > 0 && (
          <Box>
            <Tabela
              cabecalho={cabecalhoTabelaResultadoOPS}
              itensLista={_io.resultado}
              LinhaTabela={linhaTabela}
              orderCampoPadrao={'ordemPagamentoId'}
              rowsPerPageOptions={[5, 10, 15]}
              linhasPorPaginaPadrao={5}
              alinharTextoCentro={true}
              isCheckbox={true}
              handleSelectAllClick={_io.handleSelecionarTodas}
              totalSelecionados={_io.selecionadas.length}
              maxHeight={'40vh'}
            />
            <ContainerBotoes>
              <Botao textoBotao={'Cancelar'} cor="primaria" estilo="outlined" onClick={_io.limparDadosModal} />
              <Botao textoBotao={'Incluir OP(s)'} cor="primaria" estilo="contained" disabled={_io.selecionadas.length == 0} onClick={_io.handleIncluir} />
            </ContainerBotoes>
          </Box>
        )
      )}
    </CustomDialog>
  )
}
